<template lang="html">
  <div class="buildplus">
    <Header currentMenu="Account" :subMenu="productName" />
    <div class="dashboard-content-container">
      <div class="flex-box page-container">
        <Menu :currentMenu="productName" class="desktop-only" />

        <div class="content">
          <BuildPlusRenew @renew-success="reload" />

          <div class="section">
            <h2 class="black bgap-48">{{productName}}</h2>

            <div v-if="loading || reloadAccount">
              <div class="gap-3x" />
              <Spinner />
              <div class="gap-3x" />
            </div>

            <transition name="fade">
              <div v-if="!loading && !reloadAccount">
                <div v-if="(ownership.licenses < 10000 && !ownership.expired) && (ownership.canPurchase || ownership.organization_jurisdiction)">
                  <div class="section-field flex-box wrap licenses-container" v-if="ownership.canPurchase">
                    <h3 class="black pull-left bgap-24">Licenses</h3>
                    <div class="black field pull-right">
                      <div class="license">
                        <div class="body-17">Purchased</div>
                        <div class="bold license-value">{{ownership.licenses}}</div>
                        <div class="link-purple" @click="showNewLicenseModal">Add licenses</div>
                      </div>
                      <div class="license">
                        <div class="body-17">Unassigned</div>
                        <div class="bold license-value">{{ownership.license_left}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="section-field flex-box" v-if="ownership.organization_jurisdiction && !ownership.canPurchase">
                    <h3 class="black pull-left bgap-24">Jurisdiction</h3>
                    <div class="field right flex-box">
                      {{ownership.organization_jurisdiction}}
                    </div>
                  </div>
                </div>
                <div class="section-field flex-box wrap">
                  <h3 class="black pull-left bgap-24">User Management</h3>
                  <div class="field pull-right right">
                    <div>Grant and set permissions for your organization</div>
                    <div class="link-purple" @click="showPermissionsModal">What are permissions?</div>
                    <div v-if="reloadAccount">
                      <div class="gap-3x" />
                      <Spinner />
                      <div class="gap-3x" />
                    </div>
                    <AccountList
                      :accounts="accounts"
                      :availableRoles="availableRoles"
                      :canAddUser="canAddUser"
                      :productName="productName"
                      v-if="!reloadAccount"
                    />
                  </div>
                </div>

                <div v-if="!reloadAccount">
                  <div class="section-field pagination-wrapper">
                    <div class="field">
                      <BPagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="accounts.per_page"
                        :hide-goto-end-buttons="true"
                        last-number
                        first-number
                        :limit="4"
                      >
                        <template v-slot:prev-text>
                          <div :class="['control arrow-left']">
                            <i :class="['si-icon', 'si-caret_left', canGoLeft && 'active']"></i>
                          </div>
                        </template>
                        <template v-slot:next-text>
                          <div :class="['control arrow-right']">
                            <i :class="['si-icon', 'si-caret_right', canGoRight && 'active']"></i>
                          </div>
                        </template>
                      </BPagination>
                    </div>
                  </div>
                </div>

                <div class="section-field" v-if="is_admin && !ownership.expired">
                  <div class="account-footer">
                    <SymbiumButton
                      kclass="btn-base primary-btn"
                      :isPrimary="true"
                      :isSmall="true"
                      :text="addUserButton"
                      :onClick="showAddUserModal"
                    />
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <SuggestedProducts />

          <FooterHelper />
          <AddUserModal :productName="productName" />
          <NewLicensesModal />
          <PurchaseLicensesModal />
          <PermissionModal :productName="productName" />
          <ThankyouModal />
          <InvitationSentModal />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from 'src/components/dashboard/shares/Header.vue'
import Menu from 'src/components/dashboard/shares/Menu.vue'
import BuildPlusRenew from 'src/components/dashboard/shares/BuildPlusRenew.vue'
import FooterHelper from 'src/components/dashboard/shares/FooterHelper.vue'
import SuggestedProducts from 'src/components/dashboard/shares/SuggestedProducts.vue'
import Spinner from 'src/components/common/Spinner.vue'
import EventBus from 'src/components/EventBus.js'
import AccountList from 'src/components/dashboard/shares/AccountList.vue'
import AddUserModal from 'src/components/common/modals/AddUserModal.vue'
import NewLicensesModal from 'src/components/common/modals/NewLicensesModal.vue'
import PurchaseLicensesModal from 'src/components/common/modals/PurchaseLicensesModal.vue'
import PermissionModal from 'src/components/common/modals/PermissionModal.vue'
import ThankyouModal from 'src/components/common/modals/ThankyouModal.vue'
import InvitationSentModal from 'src/components/common/modals/InvitationSentModal.vue'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: {
    NewLicensesModal, AddUserModal, Header, Menu, FooterHelper, ThankyouModal,
    Spinner, SuggestedProducts, AccountList, PurchaseLicensesModal, PermissionModal,
    InvitationSentModal, BuildPlusRenew, SymbiumButton
  },
  methods: {
    assignUserData(data) {
      this.availableRoles = data.available_roles
      this.ownership = data.ownerships.find((o) => { return o.product == this.productName })
      this.canAddUser = this.ownership.can_add_more_account
      this.expires = this.ownership.expires
      this.renewed = this.ownership.renewed
      this.is_admin = data.is_admin
      this.loading = false
    },
    assignAccounts(data) {
      this.accounts = data
      this.reloadAccount = false
    },
    showAddUserModal() {
      if(this.canAddUser) {
        this.$modal.show('add-user-modal', { availableRoles: this.availableRoles });
      } else {
        this.showNewLicenseModal();
      }
    },
    showNewLicenseModal() {
      this.$modal.show('new-license-modal', this.ownership);
    },
    showPermissionsModal() {
      this.$modal.show('permission-modal');
    },
    afterLicensesPurchased() {
      this.$modal.hide('purchase-license-modal')
      this.reload()
      this.$modal.show('thankyou-modal');
    },
    afterAddUser(email) {
      this.$modal.hide('add-user-modal')
      this.reload()
      this.$modal.show('invitation-sent-modal', {
        email, organizationName:
        this.$organization.getLocalOrganizationName(),
        permissionType: 'Basic',
        productName: this.productName
      });
    },
    afterRemoveUser() {
      this.$modal.hide('remove-user-modal');
      this.reload()
    },
    reload() {
      this.loading = true
      this.$user.fetchMe();
      this.reloadAccountList();
    },
    reloadAccountList() {
      this.reloadAccount = true;
      this.$organization.fetchUsers(
        { page: this.page, productName: this.productName },
        this.assignAccounts
      );
    }
  },
  watch: {
    page() {
      this.reloadAccountList();
    },
    '$route.query.productName': function() {
      this.productName = this.$route.query.productName
      this.reload()
    }
  },
  computed: {
    canGoLeft() {
      return !this.accounts.first_page;
    },
    canGoRight() {
      return !this.accounts.last_page;
    },
    totalRows() {
      return this.accounts.per_page * this.accounts.page_count
    },
    addUserButton() {
      return `                        
        <i class="si-icon si-plus"></i>
        <span class="body-17 purple bold">Add User</span>
      `
    }
  },
  data() {
    return {
      loading: true,
      reloadAccount: false,
      suggestedProducts: [],
      canAddUser: false,
      page: 1,
      accounts: [],
      productName: null,
    }
  },
  created() {
    EventBus.$on('user-fetched', this.assignUserData)
    EventBus.$on('buildplus-user-added', this.afterAddUser)
    EventBus.$on('buildplus-license-purchased', this.afterLicensesPurchased)
    EventBus.$on('buildplus-user-removed', this.afterRemoveUser)
  },
  beforeDestroy() {
    EventBus.$off('user-fetched', this.assignUserData)
    EventBus.$off('buildplus-user-added', this.afterAddUser)
    EventBus.$off('buildplus-license-purchased', this.afterLicensesPurchased)
    EventBus.$off('buildplus-user-removed', this.afterRemoveUser)
  },
  mounted() {
    this.productName = this.$route.query.productName
    this.reload()
  }
}
</script>

<style lang="scss">
.account-footer {
  text-align: right;

  .si-plus {
    color: var(--purple);
    font-weight: bold;
    display: inline;
    padding-right: 4px;
  }
}

.buildplus {
  .pull-left {
    float: left;
  }

  .pull-right {
    float: left;
    width: 100%;
  }

  .licenses-container {
    overflow: hidden;

    .license {
      width: 50%;
      float: left;
    }
  }
  .pagination-wrapper {
    overflow: hidden;
    padding: 24px 0 24px !important;

    .field {
      float: right;
      width: calc(50% + 164px);
      min-width: unset;
      max-width: unset;
      margin-right: calc(50% - 464px);
    }
  }

  ul.pagination {
    margin: 0;

    li {
      margin: 0 16px;

      span:focus, button:focus {
        box-shadow: none;
      }

      * {
        color: var(--gray);
      }

      button, span.page-link {
        background-color: inherit;
        border: none;
        padding: 0;
        text-align: center;
        width: 100%;
      }

      &.active * {
        color: var(--black);
        background-color: inherit;
      }

      &:last-child, &:first-child {
        margin: 0;
        flex: 1;
        button {
          width: 100%;
        }
      }
    }

    .control {
      .si-icon {
        font-weight: bold;
        font-size: 18px;
        color: var(--gray187);
        cursor: default;

        &.active {
          color: var(--black);
          cursor: pointer;
        }
      }

      &.arrow-left {
        width: 100%;
        text-align: left;
      }

      &.arrow-right {
        width: 100%;
        text-align: right;
      }
    }
  }
}

@media screen and (max-width: 1068px) {
  .buildplus .dashboard-content-container {
    .pagination-wrapper .field {
      width: 100%;
      margin: 0;
    }
  }
}

@media screen and (max-width: 768px) {
  .buildplus .dashboard-content-container {
    .licenses-container {
      display: block;

      .left, .right {
        padding: 0;
      }
    }

    .account-footer {
      padding: 0 24px;
    }
  }
}
</style>
